'use strict';

var Stringify = require('./stringify');
var Parse = require('./parse');

module.exports = {
    stringify: Stringify,
    parse: Parse
};



//////////////////
// WEBPACK FOOTER
// ./~/dibs-service-fetch-wrappers/~/qs/lib/index.js
// module id = 515
// module chunks = 4 6 8 9 16 17 22 26 29 58